import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";

export const InputLabel = styled.div`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.three};
  margin-bottom: ${SPACING.one}px;
`;

export const InputContainer = styled.div`
  padding-bottom: ${SPACING.three}px;
`;

export const InputError = styled.div`
  ${FONT_CSS.label.three}
  color: ${COLORS.negative.one};
  padding-top: ${SPACING.one}px;
`;

export const ErrorMessage = styled.p`
  ${FONT_CSS.label.three}
  color: ${COLORS.negative.one};
  margin: 0;
  margin-top: ${SPACING.three}px;
  margin-bottom: ${SPACING.two}px;
`;

export const ApprovalSuccessMessage = styled.div`
  ${FONT_CSS.label.three}
  color: ${COLORS.highlight.one};
  margin-bottom: ${SPACING.three}px;
`;

export const Spacer = styled.div`
  margin-top: ${SPACING.three}px;
`;

export const ButtonsContainer = styled.div`
  display: flex;

  > * {
    &:not(:last-child) {
      margin-right: ${SPACING.two}px;
    }
  }
`;

export const Footer = styled.div`
  ${FONT_CSS.body.five}
  margin-top: ${SPACING.three}px;
  padding: ${SPACING.two}px;
  border-radius: ${BORDER_RADIUS.five}px;
  background-color: ${COLORS.highlight.six};
  color: ${COLORS.highlight.one};
`;

export const DepositAssetDropdownTitle = styled.div`
  ${FONT_CSS.data.three}
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 42px;
  color: ${TEXT_COLORS.two};
  > span {
    margin-left: ${SPACING.one}px;
  }
`;

export const DepositAssetDropdownItem = styled(DepositAssetDropdownTitle)<{
  selected: boolean;
}>`
  padding: ${SPACING.one}px;
  justify-content: flex-start;
  width: 112px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  &:hover {
    color: ${TEXT_COLORS.one};
  }

  ${({ selected }) =>
    selected &&
    css`
      color: ${TEXT_COLORS.one};
    `}
`;

export const WalletQrCode = styled.div`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  border-radius: ${BORDER_RADIUS.three}px;
  background-color: ${COLORS.white.one};
  border: 1px solid ${BORDER_COLORS.one};
  display: flex;
  align-items: center;
  justify-content: center;
`;
